import React, { useState } from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "src/components/dialogue/radix-dialog";
import { useAddInventory } from "../../hooks/inventory/useAddInventory";
import { useUpdateInventory } from "../../hooks/inventory/useUpdateInventory";

const AddStockModal = ({
  children,
  name,
  id,
  stock,
  open,
  onOpenChange,
}: {
  children: React.ReactNode;
  name: string;
  id: string;
  stock: number;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const [restockQty, setRestockQty] = useState<number>(10);

  const { mutate: updateStock, isPending: isUpdating } = useUpdateInventory();
  const { mutate: addStock, isPending: isAdding } = useAddInventory();

  const handleAddStock = async () => {
    addStock({
      qty: restockQty,
      productId: id,
    });
  };

  const handleUpdateStock = () => {
    updateStock({
      productId: id,
      quantity: restockQty,
    });
  };

  const handleStockUpdate = () => {
    if (stock > 0) {
      handleUpdateStock();
    } else {
      handleAddStock();
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger className="flex-1" asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="max-h-[70vh] w-full bg-white rounded-3xl spacey-6 max-w-2xl p-8">
        <h3 className="text-xl font-black text-center text-slate-800">
          Adjust Inventory
        </h3>
        <p className="text-center text-xs font-bold text-slate-400 uppercase tracking-widest">
          Update stock for {name}
        </p>
        <input
          type="number"
          className="w-full bg-slate-50 border p-6 text-3xl font-black text-center text-emerald-600 rounded-2xl focus:ring-4 focus:ring-emerald-500/10 outline-none transition-all"
          value={restockQty}
          onChange={(e) => setRestockQty(parseInt(e.target.value) || 0)}
        />
        <div className="flex gap-4">
          <DialogClose className="">
            <button className="w-full font-bold text-slate-400 transition-colors rounded-xl border border-red-200 hover:bg-red-50 hover:text-red-400 hover:border-transparent h-full px-4">
              Cancel
            </button>
          </DialogClose>
          <DialogClose className="flex-1 w-full">
            <button
              onClick={handleStockUpdate}
              disabled={isAdding || isUpdating}
              className="flex-1 w-full bg-emerald-600 text-white py-4 rounded-xl font-bold shadow-lg hover:bg-emerald-700 transition-all active:scale-95"
            >
              {isAdding ? "Adding Stock..." : "Add Stock"}
            </button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddStockModal;
